<div class="profile-templates" *ngIf="selectedprofile==null">
    <div class="profile-card" *ngFor="let profile of evaluatedProfiles; let i = index">
        <img [src]="getImagePath(profile)" alt="{{ 'common.profileTemplate' | translate }} {{ i + 1 }}">
        <div class="buttons">
            <button class="view-evaluation" (click)="getProfileScanDetails(profile)">
                {{'View Evaluation'|translate}}
            </button>
        </div>

    </div>

</div>
<div class="profile-evaluation-details" *ngIf="selectedprofile!==null">

    <app-linkdin-evaluation [selectedprofile]="selectedprofile"></app-linkdin-evaluation>

</div>